import { useEffect, useRef } from 'react';

type ResettableForm<TValues> = {
  reset: (values?: TValues) => void;
};

/**
 * Resets a TanStack form to its default values exactly once, after the initial
 * async data has finished loading. Later changes to `defaultValues` (e.g. from
 * user edits) are intentionally ignored so in-progress input is never clobbered.
 */
export function useResetFormOnLoad<TValues>(
  form: ResettableForm<TValues>,
  defaultValues: TValues,
  isLoading: boolean,
): void {
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    if (isLoading || hasInitializedRef.current) {
      return;
    }

    hasInitializedRef.current = true;
    form.reset(defaultValues);
  }, [isLoading, defaultValues, form]);
}
